<template>
    <div>
        <Welcome></Welcome>
        <Contacts></Contacts>
    </div>
</template>


<script>
import Welcome from "./Welcome.vue"
import Contacts from "./Contacts.vue"

export default {
    components: { Welcome, Contacts }
}
</script>

<style>

.text-align-left {
    text-align: left;
}
</style>